// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"335":"536d0e88","548":"5bdff4f7"}[chunkId] + ".chunk.css";
};